import React, { useState } from 'react';
import { Badge } from '../../../components/Badge';
import { Button } from '../../../components/Button';
import { Card } from '../../../components/Card';
import { Modal } from '../../../components/Modal';
import { Section } from '../../../components/Section';
import { CiCalendar, CiLocationOn, CiUser, CiDroplet, CiLock } from 'react-icons/ci';
import { PiFactoryThin } from 'react-icons/pi';
import { IconWrap } from '../../../components/IconWrap';
import useTheme from '../../../hooks/useTheme';

export const FeaturedItems: React.FC = () => {
    const { theme } = useTheme();
    const [isRSVPModalOpen, setIsRSVPModalOpen] = useState(false);

    const opportunities = [
        {
            title: 'Korean wastewater solutions partner search (Egypt)',
            sector: 'Water & Wastewater',
            country: 'Egypt',
            stage: 'Draft',
            icon: <CiDroplet />,
        },
        {
            title: 'Egyptian industrial supplier matchmaking (Korea)',
            sector: 'Industrial Products',
            country: 'Korea',
            stage: 'Screening',
            icon: <PiFactoryThin />,
        },
        {
            title: 'Infrastructure project collaboration opportunity',
            sector: 'Infrastructure',
            country: 'Egypt',
            stage: 'Intro ready',
            icon: <CiDroplet />,
        },
    ];

    return (
        <Section>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '24px',
                }}
                className="featuredGrid"
            >
                <Card>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: '20px',
                        }}
                    >
                        <h3
                            style={{
                                fontSize: '22px',
                                fontWeight: 600,
                                color: theme.text.primary,
                            }}
                        >
                            Business Opportunities Exchange
                        </h3>
                        <Badge status="COMING SOON" />
                    </div>
                    <p
                        style={{
                            color: theme.text.muted,
                            marginBottom: '24px',
                            lineHeight: 1.6,
                        }}
                    >
                        Connect with business opportunities between Korea and Egypt. Submit opportunities or browse available matches.
                    </p>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                        }}
                    >
                        {opportunities.map((opp, idx) => (
                            <div
                                key={idx}
                                style={{
                                    padding: '16px',
                                    backgroundColor: theme.background.panel,
                                    borderRadius: theme.borderRadius.r1,
                                    border: `1px solid ${theme.colors.line}`,
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        marginBottom: '8px',
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: '24px',
                                            color: theme.colors.green.g1,
                                        }}
                                    >
                                        {opp.icon}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: '16px',
                                            fontWeight: 500,
                                            color: theme.text.primary,
                                        }}
                                    >
                                        {opp.title}
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        gap: '12px',
                                        flexWrap: 'wrap',
                                        marginBottom: '12px',
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: '12px',
                                            color: theme.text.muted,
                                            padding: '4px 8px',
                                            backgroundColor: theme.background.card,
                                            borderRadius: '4px',
                                        }}
                                    >
                                        {opp.sector}
                                    </span>
                                    <span
                                        style={{
                                            fontSize: '12px',
                                            color: theme.text.muted,
                                            padding: '4px 8px',
                                            backgroundColor: theme.background.card,
                                            borderRadius: '4px',
                                        }}
                                    >
                                        {opp.country}
                                    </span>
                                    <span
                                        style={{
                                            fontSize: '12px',
                                            color: theme.text.muted,
                                            padding: '4px 8px',
                                            backgroundColor: theme.background.card,
                                            borderRadius: '4px',
                                        }}
                                    >
                                        {opp.stage}
                                    </span>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        gap: '8px',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Button
                                        variant="ghost"
                                        disabled
                                        style={{ fontSize: '13px', padding: '8px 16px', flex: 1 }}
                                    >
                                        <IconWrap icon={<CiLock />} size={14} color="muted" />
                                        <span style={{ marginLeft: '6px' }}>Submit</span>
                                    </Button>
                                    <Button
                                        variant="ghost"
                                        disabled
                                        style={{ fontSize: '13px', padding: '8px 16px', flex: 1 }}
                                    >
                                        <IconWrap icon={<CiLock />} size={14} color="muted" />
                                        <span style={{ marginLeft: '6px' }}>Apply</span>
                                    </Button>
                                </div>
                                <p
                                    style={{
                                        fontSize: '11px',
                                        color: theme.text.muted,
                                        marginTop: '8px',
                                        textAlign: 'center',
                                        fontStyle: 'italic',
                                    }}
                                >
                                    Module opens in Phase 3
                                </p>
                            </div>
                        ))}
                    </div>
                </Card>

                <Card>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: '20px',
                        }}
                    >
                        <h3
                            style={{
                                fontSize: '22px',
                                fontWeight: 600,
                                color: theme.text.primary,
                            }}
                        >
                            Featured Event
                        </h3>
                        <Badge status="LIVE" />
                    </div>
                    <div
                        style={{
                            padding: '16px',
                            backgroundColor: theme.background.panel,
                            borderRadius: theme.borderRadius.r1,
                            border: `1px solid ${theme.colors.line}`,
                            marginBottom: '20px',
                        }}
                    >
                        <div
                            style={{
                                fontSize: '18px',
                                fontWeight: 600,
                                color: theme.text.primary,
                                marginBottom: '12px',
                            }}
                        >
                            BCBH Launch Ceremony & MoU Signing
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px',
                                marginBottom: '16px',
                                color: theme.text.muted,
                                fontSize: '14px',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <IconWrap icon={<CiCalendar />} size={18} color="primary" />
                                <span>March 26, 2025</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <IconWrap icon={<CiLocationOn />} size={18} color="primary" />
                                <span>Cairo, Egypt</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <IconWrap icon={<CiUser />} size={18} color="primary" />
                                <span>In-person</span>
                            </div>
                        </div>
                        <p
                            style={{
                                color: theme.text.muted,
                                fontSize: '14px',
                                lineHeight: 1.6,
                                marginBottom: '16px',
                            }}
                        >
                            Official launch of the BUSAN–CAIRO BUSINESS HUB with MoU signing ceremony between BTEC, LOHMANN ECCE, and BTP.
                        </p>
                        <Button
                            variant="primary"
                            onClick={() => setIsRSVPModalOpen(true)}
                            style={{ width: '100%' }}
                        >
                            RSVP
                        </Button>
                    </div>
                </Card>
            </div>

            <Modal
                isOpen={isRSVPModalOpen}
                onClose={() => setIsRSVPModalOpen(false)}
                title="RSVP Coming Soon"
            >
                <p style={{ color: theme.text.muted, lineHeight: 1.6 }}>
                    Event RSVP functionality will be available in Phase 2 of the BCBH portal. For now, please contact us directly to express your interest in attending events.
                </p>
                <div style={{ marginTop: '24px' }}>
                    <Button variant="primary" onClick={() => setIsRSVPModalOpen(false)}>
                        Got it
                    </Button>
                </div>
            </Modal>
        </Section>
    );
};

